const accHD = document.getElementsByClassName('accordion-title');

function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

docReady(() => {
  function toggleItem() {
    const itemClass = this.parentNode.className;
    const chevron = this.parentNode.querySelector('.wp-block-riverdale-accordiontitle-chevron');
    const plusIcon = this.parentNode.querySelector('.circle-plus');

    if (itemClass === 'wp-block-riverdale-accordionitem close') {
      this.parentNode.className = 'wp-block-riverdale-accordionitem open';
      plusIcon.className = 'circle-plus opened';
      chevron.setAttribute('aria-label', 'close');
    } else {
      this.parentNode.className = 'wp-block-riverdale-accordionitem close';
      plusIcon.className = 'circle-plus closed';
      chevron.setAttribute('aria-label', 'open');
    }
  }

  for (let i = 0; i < accHD.length; i += 1) {
    accHD[i].addEventListener('click', toggleItem, false);

    accHD[i].addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        accHD[i].click();
      }
    });
  }
});
